import React from 'react';

import LeftMenuSection from '../../beatport/content/LeftMenuSection';

function MyPlaylistsMenuSection({ onSelectGenres }) {
  return <LeftMenuSection onSelectGenres={onSelectGenres} />
}

export default MyPlaylistsMenuSection;
